import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Throwing } from '../models/common';
import { webApiGet } from '../api/client';
import { UserData } from './apiModels';
import { AppThunk } from '../store/store';


export interface AdminState extends Throwing {
  getUsersBusy: boolean,
  usersList: UserData[] | null
}
const initialState: AdminState = {
  getUsersBusy: false,
  usersList: null
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    getUsersRequest: (state) => {
        state.getUsersBusy = true
        state.error = undefined
    },
    getUsersResponse: (state, action: PayloadAction<UserData[]>) => {
        state.getUsersBusy = false
        state.usersList = action.payload
    },
    getUsersError: (state, action: PayloadAction<Error>) => {
        state.getUsersBusy = false
        state.error = action.payload
    }
  }
});

export const getUsersAsync = (): AppThunk => dispatch => {
  dispatch(adminSlice.actions.getUsersRequest())

  webApiGet(
    "/users",
    (data: any) => {
      dispatch(adminSlice.actions.getUsersResponse(data));
    },
    (error: Error) => {
      dispatch(adminSlice.actions.getUsersError(error));
    }, null, 3
  )
};

export default adminSlice.reducer;